export default __webpack_public_path__ + "static/media/site-tracking-event.2af335be.svg";